import React from 'react';
import { MessageCircle } from 'lucide-react';
import { openWhatsApp } from '../lib/whatsapp';

const WhatsAppButton = () => {
  const handleClick = () => {
    openWhatsApp('Hola, me gustaría solicitar información sobre sus servicios.');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full p-4 shadow-lg transition-all duration-300 hover:scale-110 group"
      aria-label="Contactar por WhatsApp"
    >
      <MessageCircle className="w-7 h-7" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Contáctanos por WhatsApp
      </span>
    </button>
  );
};

export default WhatsAppButton;
